module.exports = __webpack_public_path__ + "img/weixin.20afb7f4.png";